import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState } from "react";
// import { lazy, Suspense } from 'react';
import { useDispatch, useSelector } from "react-redux";

import "./components/design/legacyCSS.css";
import { Helmet } from "react-helmet";
import { useHubspotChat } from "./hubspot";
import hubspotChatOpen from "./assets/hubspot-chat-open.svg";
import hubspotChatClose from "./assets/hubspot-chat-close.svg";
import { enqueueSnackbar, SnackbarProvider } from "notistack";

//NOTE: Component imports
import Navbar from "./components/shared/navbar/Navbar";
import Login from "./components/login/Login";
import LoginScreen2 from "./components/login/LoginScreen2";
import Signup from "./components/signup/Signup";
import Invite from "./components/invite-flow/Invite";
import PlatformRules from "./components/platform-rules/PlatformRules";
import ActivityLogs from "./components/ActivityLogs/ActivityLogs";
import CustomSnackbar from "./components/design/components/CustomSnackbar.jsx";
import SignupScreen2 from "./components/signup/SignupScreen2";
import SignupScreen4 from "./components/signup/SignupScreen4";
import SignupAccountType from "./components/signup/SignupAccountType.jsx";
import ForgotPassword from "./components/forgot-password/ForgotPassword";
import PageNotFound from "./components/page-not-found/PageNotFound";
import Dashboard from "./components/dashboard/dashboard";
import Settings from "./components/settings/Settings";
import DataRetentionAuditLog from "./components/settings/DataRetentionAuditLog.jsx";
import AppDetailsPage from "./components/settings/developer/AppDetailsPage.jsx";
import Kyb from "./components/kyb/Kyb.jsx";
import Denied from "./components/denied/Denied";
import SharedCallRecording from "./components/shared-call-recording/SharedCallRecording";
import ForgotPasswordVerify from "./components/forgot-password/ForgotPasswordVerify";
import ForgotPasswordReset from "./components/forgot-password/ForgotPasswordReset";
import ContactLists from "./components/contact-lists/ContactLists";
import TeamView from "./components/users-and-teams/teams/TeamView";
import ContactListsView from "./components/contact-lists-view/ContactListsView";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute.js";
import UsersAndTeam from "./components/users-and-teams/UsersAndTeams";
import VirtualNumber from "./components/virtual-numbers/VirtualNumber";
import VirtualNumberView from "./components/virtual-number-view/VirtualNumberView";
import Autodial from "./components/autodial/Autodial";
import AutodialView from "./components/autodial-view/AutodialView";
import Survey from "./components/survey/Survey.jsx";
import SurveyView from "./components/survey/SurveyView.jsx";
import MessageTemplates from "./components/message-templates/MessageTemplates";

import Oauth from "./components/settings/Oauth";
import Billing from "./components/billing/Billing";
import AccountSuspended from "./components/AccountSuspended/AccountSuspended.js";
import CallPricing from "./components/call-pricing/CallPricing";
import CallRecordingNew from "./components/call-recording-new/CallRecordingNew.jsx";
import { useEffect } from "react";
import {
  setPermissionsList,
  setUserRoles,
} from "./components/features/permission/permission.js";
import { fetchData, isSuspended } from "./utility-functions/index.js";
import {
  storePermissions,
  storeValidPaths,
} from "./components/features/permission/auth.js";
import {
  JService,
  safeLogout,
  devmode,
} from "./components/api-service/ApiService.js";
import PermissionDenied from "./components/denied/PermissionDenied.jsx";
import { setRedirectOnAuth } from "./components/features/user/user.js";
import FirstLogin from "./components/FirstLogin.jsx";
import Chat from "./components/whatsapp-business/Chat/Chat.jsx";
import Templates from "./components/whatsapp-business/Template/Templates.jsx";
import CreateTemplate from "./components/whatsapp-business/Template/CreateTemplate.jsx";
import { app } from "./firebase";
import { getToken, onMessage, getMessaging, isSupported } from "firebase/messaging";
import ViaSocketIntegrationPage from "./components/settings/ViaSocketIntegrationPage.jsx";
import { RefreshContext } from "./contexts/RefreshContext.js";
import { setWhatsappCredentials } from "./components/features/whatsapp-business/whatsappBusiness.js";
import { handleFcmData } from "./fcmHandler.js";
import Ivr from "./components/virtual-number-view/ivr/ivr.jsx";
import SignupKyc from "./components/signup/SignupKyc.jsx";
import Upgrade from "./components/UpgradePlan/Upgrade.jsx";

import Cart from "./components/billing/Cart.jsx";
import SubscriptionGuard from "./components/SubscriptionGuard.jsx";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_PUBLIC_VAPID_KEY;
const FREJUN_BASE_URL = process.env.REACT_APP_FREJUN_BASE_URL;

const SeoFreindlyLogin = () => {
  return (
    <>
      <Helmet>
        <title>Login - FreJun</title>
        <meta
          name="description"
          content="Login to your FreJun account to make outbound calls and access your call recordings with call metrics."
        />
        <meta name="keywords" content="cloud telephony" />
      </Helmet>
      <Login />
    </>
  );
};

export default function App() {
  const dispatch = useDispatch();

  const reduxSubscription = useSelector(
    (state) => state?.account?.value?.subscription
  );
  const accessList = useSelector(
    (state) => state?.account?.value?.data?.access_list
  );
  const userRoles = useSelector((state) => state?.auth?.userRoles);
  const permissions = useSelector((state) => state?.auth?.permissions);
  const isLoggedIn = useSelector((state) => state?.user?.value?.isLoggedIn);
  const loginSource = useSelector((state) => state?.user?.value?.source);
  const email = useSelector((state) => state?.account?.value?.data?.email);
  const appState = useSelector((state) => state?.app?.value);

  //States
  const [refreshData, setRefreshData] = useState(false);

  //Handlers
  const checkParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const fromSupport = searchParams.get("support");
    const addVN = searchParams.get("add-vn");
    // open widget
    if (fromSupport || addVN) {
      console.log("opening widget");
      handleToggleWidget();
    }
  };

  const { handleToggleWidget, isWidgetOpen } = useHubspotChat(
    "5132602",
    checkParams
  );

  const sendTokenToServer = async (token) => {
    if (!token || !email) return;
    const payload = JSON.stringify({
      registration_id: token,
      type: "web",
      email: email,
      source: "web-app",
    });
    try {
      const response = await JService.post(
        "/api/v1/auth/register-fcm-device/",
        payload
      );
      if (!response?.success)
        throw new Error(
          response?.message || "Error while sending FCM token to server"
        );
    } catch (error) {
      enqueueSnackbar(
        error?.message || "Error while sending FCM token to server",
        { variant: "error" }
      );
    }
  };

  //Effects
  useEffect(() => {
    if (!isLoggedIn) return;
    const setRoles = (roles) => dispatch(setUserRoles(roles));
    fetchData("/api/v1/auth/retrieve-user-roles/", setRoles, "user roles");

    const setPermissions = (permissions) =>
      dispatch(setPermissionsList(permissions));
    fetchData(
      "/api/v1/auth/retrieve-permissions/",
      setPermissions,
      "permissions"
    );

    const setWhatsappCreds = (creds) => dispatch(setWhatsappCredentials(creds));
    fetchData(
      "/api/v1/whatsapp/embedded-signup/",
      setWhatsappCreds,
      "whatsapp credentials"
    );
  }, [isLoggedIn]);

  useEffect(() => {
    console.log(
      "userRoles",
      userRoles,
      userRoles.length,
      permissions?.canAccessWebApp
    );
    if (
      userRoles &&
      userRoles.length &&
      permissions &&
      Object.keys(permissions).length &&
      !permissions.canAccessWebApp
    ) {
      safeLogout();
      return;
    }
    if (userRoles && userRoles.length) {
      storePermissions();
      storeValidPaths();
    }
    if (loginSource === "signup") {
      dispatch(setRedirectOnAuth(true));
    }
  }, [userRoles, accessList, loginSource]);

  useEffect(() => {
    if (!email || !appState) return;

    let unsubscribeOnMessage = null;
    let swHandler = null;

    async function setupFCM() {
      if (!(await isSupported())) {
        console.log("FCM is NOT supported in this browser/device.");
        return;
      }

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("Notification permission not granted");
        return;
      }

      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

        const messaging = getMessaging(app);

        const currentToken = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: registration,
        });

        if (currentToken) {
          sendTokenToServer(currentToken);
        }

        unsubscribeOnMessage = onMessage(messaging, (payload) => {
          const { data } = payload;
          if (!data) return;

          handleFcmData(dispatch, data);

          if (appState !== "Business phone" && data.update === "message_received") {
            const notif = new Notification(
              "New message from " + (data.sender_name || data.sender_number),
              {
                body: data.message,
                icon: "/logo.svg",
              }
            );
            notif.onclick = () => {
              window.location.href = `${FREJUN_BASE_URL}/w-chat`;
              window.location.reload();
            };
          }

          if (data.type === "create_contact_list") {
            const notif = new Notification("New contact list created", {
              body: data?.message,
              icon: "/logo.svg",
            });
            notif.onclick = () => {
              window.location.href = `${FREJUN_BASE_URL}/contact-lists`;
            };
          } else if (data.type === "update_contact_list") {
            const listUrl = `${FREJUN_BASE_URL}/contact-lists/${data?.id}`;
            const notif = new Notification("Contacts added", {
              body: data?.message + " Click refresh to see changes",
              icon: "/logo.svg",
            });
            notif.onclick = () => {
              window.location.href = listUrl;
            };
          }
        });

        swHandler = (e) => {
          if (e.data?.type === "NEW_FCM_MESSAGE") {
            handleFcmData(dispatch, e.data.data);
          }
        };
        navigator.serviceWorker.addEventListener("message", swHandler);
      } catch (err) {
        console.error("Service Worker registration failed:", err);
      }
    }

    setupFCM();

    return () => {
      if (unsubscribeOnMessage) unsubscribeOnMessage();
      if (swHandler)
        navigator.serviceWorker.removeEventListener("message", swHandler);
    };
  }, [email, appState]);


  return (
    <>
      <BrowserRouter>
        {/* <Suspense fallback={<AnimationPage/>}> */}
        <SnackbarProvider
          autoHideDuration={6000}
          maxSnack={1}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
          Components={{
            success: CustomSnackbar,
            error: CustomSnackbar,
          }}
        />

        {/* page meta and navbar */}
        <RefreshContext.Provider value={{ refreshData, setRefreshData }}>
          <Navbar
            isWidgetOpen={isWidgetOpen}
            handleToggleWidget={handleToggleWidget}
          />
          <FirstLogin />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<SeoFreindlyLogin />} />
            <Route path="/invite" element={<Invite />} />
            <Route path="/login/verification" element={<LoginScreen2 />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signup/verification" element={<SignupScreen2 />} />
            <Route path="/signup/company-details" element={<SignupScreen4 />} />
            <Route
              path="/signup/account-type"
              element={<SignupAccountType />}
            />
            <Route path="/signup/kyc" element={<SignupKyc />} />
            <Route path="/account-suspended" element={<AccountSuspended />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/forgot-password/verification"
              element={<ForgotPasswordVerify />}
            />
            <Route
              path="/forgot-password/reset"
              element={<ForgotPasswordReset />}
            />
            {isProductAccessible(reduxSubscription) && (
              <>
                {/* ------------------Whatsapp routes----------------------- */}

                <Route
                  element={
                    <ProtectedRoute
                      category="whatsapp business"
                      action="send message"
                    />
                  }
                >
                  <Route
                    element={<SubscriptionGuard tabName="WhatsApp inbox" />}
                  >
                    <Route path="/w-chat" element={<Chat />} />
                  </Route>
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      category="whatsapp business"
                      action="message templates"
                    />
                  }
                >
                  <Route
                    element={<SubscriptionGuard tabName="WhatsApp templates" />}
                  >
                    <Route path="/w-template" element={<Templates />} />
                    <Route
                      path="/w-template/create"
                      element={<CreateTemplate />}
                    />
                  </Route>
                </Route>

                {/* ---------------------------------------------------------- */}
                <Route element={<ProtectedRoute action="dashboard" />}>
                  <Route element={<SubscriptionGuard tabName="Dashboard" />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                  </Route>
                </Route>
                <Route
                  element={
                    <ProtectedRoute category={["users and roles", "teams"]} />
                  }
                >
                  <Route path="/users-and-teams" element={<UsersAndTeam />} />
                  <Route path="/teams/:id" element={<TeamView />} />
                </Route>
                <Route>
                  <Route
                    path="via-socket-integration"
                    element={<ViaSocketIntegrationPage />}
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute category="billing and subscriptions" />
                  }
                >
                  <Route path="/billing" element={<Billing />} />
                  <Route path="/billing/cart" element={<Cart />} />
                </Route>
                <Route element={<ProtectedRoute category="contacts" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Contact lists" />}
                  >
                    <Route path="/contact-lists" element={<ContactLists />} />
                    <Route
                      path="/contact-lists/:id"
                      element={<ContactListsView />}
                    />
                  </Route>
                </Route>

                <Route element={<ProtectedRoute action="call logs" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Activity logs" />}
                  >
                    <Route
                      path="/activity-logs/calls"
                      element={<ActivityLogs tab="Calls" />}
                    />
                  </Route>
                </Route>
                <Route element={<ProtectedRoute action="sms logs" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Activity logs" />}
                  >
                    <Route
                      path="/activity-logs/messages"
                      element={<ActivityLogs tab="Messages" />}
                    />
                    <Route
                      path="/messages/:id"
                      element={<ActivityLogs tab="Messages" />}
                    />
                  </Route>
                </Route>
                <Route element={<ProtectedRoute action="manage ivr flow" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Virtual numbers" />}
                  >
                    <Route path="/virtual-numbers/ivr/edit" element={<Ivr />} />
                  </Route>
                </Route>
                <Route element={<ProtectedRoute action="message templates" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Message templates" />}
                  >
                    <Route path="/messages" element={<MessageTemplates />} />
                  </Route>
                </Route>
                <Route element={<ProtectedRoute category="numbers" />}>
                  <Route
                    element={<SubscriptionGuard tabName="Virtual numbers" />}
                  >
                    <Route
                      path="/virtual-numbers"
                      element={
                        <VirtualNumber
                          isWidgetOpen={isWidgetOpen}
                          handleToggleWidget={handleToggleWidget}
                        />
                      }
                    />
                    {/* <Route path="/virtual-numbers/add-number" element={<AddVirtualNumber/>}/> */}
                    <Route
                      path="/virtual-numbers/:number"
                      element={<VirtualNumberView />}
                    />
                  </Route>
                </Route>
                {accessList?.includes("AUTODIAL") && (
                  <Route element={<SubscriptionGuard tabName="Autodial" />}>
                    <Route path="/autodial" element={<Autodial />} />
                    <Route path="/autodial/:id" element={<AutodialView />} />
                  </Route>
                )}
                {accessList?.includes("IVR SURVEY") && (
                  <Route element={<ProtectedRoute category="surveys" />}>
                    <Route element={<SubscriptionGuard tabName="Surveys" />}>
                      <Route path="/survey" element={<Survey />} />
                      <Route path="/survey/:id" element={<SurveyView />} />
                    </Route>
                  </Route>
                )}
                <Route path="/oauth/authorize" element={<Oauth />} />
                <Route path="/settings" element={<Settings />} />
                {/* TEMP: internal-only KYB tester, hidden on production */}
                {devmode && <Route path="/kyb" element={<Kyb />} />}
                <Route
                  element={
                    <ProtectedRoute
                      category="organization settings"
                      action="data retention"
                    />
                  }
                >
                  <Route
                    path="/settings/audit-log"
                    element={<DataRetentionAuditLog />}
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      category="org level settings"
                      action="manage developer settings"
                    />
                  }
                >
                  <Route
                    path="/settings/apps/:id"
                    element={<AppDetailsPage />}
                  />
                </Route>
                <Route
                  path="/interviews/shared-interview/:id"
                  element={
                    <SharedCallRecording
                      isWidgetOpen={isWidgetOpen}
                      handleToggleWidget={handleToggleWidget}
                    />
                  }
                />
                <Route
                  path="/call-recording/:id"
                  element={
                    <CallRecordingNew
                      isWidgetOpen={isWidgetOpen}
                      handleToggleWidget={handleToggleWidget}
                    />
                  }
                />
                <Route path="/deny" element={<Denied />} />
                <Route path="/platform-rules" element={<PlatformRules />} />
              </>
            )}
            <Route path="/upgrade" element={<Upgrade />} />
            <Route path="/permission-denied" element={<PermissionDenied />} />
            <Route path="/call-pricing-usd" element={<CallPricing />} />
            <Route path="/call-pricing-inr" element={<CallPricing />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          {/* </Suspense> */}
        </RefreshContext.Provider>
        <ChatSupport
          isWidgetOpen={isWidgetOpen}
          handleToggleWidget={handleToggleWidget}
        />
      </BrowserRouter>
    </>
  );
}

const isProductAccessible = (subscription) => {
  const isAccountSuspended = isSuspended(subscription?.status);
  
  const isTrialPreActivation = subscription?.status === "PRE_ACTIVATION";
  return !isAccountSuspended || isTrialPreActivation;
};

function ChatSupport({ isWidgetOpen, handleToggleWidget }) {
  const location = useLocation();
  let paths = ["/w-template/create/", "/w-chat/"];
  if (
    paths.includes(location.pathname) ||
    paths.includes(location.pathname + "/")
  ) {
    return null;
  }
  return (
    <div style={localStyles.chatSupportContainer}>
      <button
        style={localStyles.chatSupportButton}
        onClick={handleToggleWidget}
      >
        <img
          src={isWidgetOpen ? hubspotChatClose : hubspotChatOpen}
          alt="open chat"
        />
      </button>
    </div>
  );
}

const localStyles = {
  chatSupportContainer: {
    position: "fixed",
    right: "16px",
    bottom: "16px",
    width: "70px",
    height: "70px",
    zIndex: "10",
  },
  chatSupportButton: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    backgroundColor: "#00a4bd",
    display: "block",
  },
};

// removed paths
// {/* <Route path="/add-account" element={<AddAccount />} /> */}
// {/* <Route path="/call-logs/:id" element={<CallRecording />} /> */}
// {/* <Route path="/voice-broadcast" element={<VoiceBroadcast />} /> */}
// {/* <Route path="/voice-broadcast/:id" element={<VoiceBroadcastView />} /> */}
